export default function Marquee({ items, dark = false, testid }) {
  const Row = ({ hidden }) => (
    <div aria-hidden={hidden} className="flex shrink-0 items-center">
      {[0, 1, 2, 3].map((rep) =>
        items.map((item, i) => (
          <span key={`${rep}-${i}`} className="flex items-center">
            <span
              className={`whitespace-nowrap font-sans text-xs tracking-[0.45em] ${
                dark ? "text-bone/70" : "text-ink/70"
              }`}
            >
              {item}
            </span>
            <span className={`mx-8 font-sans text-xs ${dark ? "text-bone/35" : "text-ink/35"}`}>
              //
            </span>
          </span>
        ))
      )}
    </div>
  );

  return (
    <div
      data-testid={testid}
      className={`overflow-hidden border-y py-4 ${dark ? "border-bone/15" : "border-ink/15"}`}
    >
      <div className="animate-marquee flex w-max">
        <Row hidden={false} />
        <Row hidden={true} />
      </div>
    </div>
  );
}
